// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageContentComponent from '../components/ui/pageContentComponent';
import PageContainerTitleComponent from '../components/ui/container/pageContainerTitleComponent';
import styled from 'styled-components';
import { FaDiscord, FaEnvelope } from 'react-icons/fa';

const SupportContainer = styled.div`
  text-align: center;
  margin-top: 20px;
  font-size: 18px;
  color: #fff;
`;

const SupportItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 10px 0;
  font-size: 20px;
`;

const SupportLink = styled.a`
  color: #00aaff;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    color: #ffcc00;
    text-decoration: underline;
  }
`;

const SupportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
const SupportEmailMailTo = 'mailto:' + SupportEmail;
const DiscordUrl = process.env.REACT_APP_DISCORD_URL;

const SupportPage = () => {
  const { t } = useTranslation();

  return (
    <PageContentComponent>
      <PageContainerTitleComponent title={t('supportPage.title')} />
      <SupportContainer>
        <p>{t('supportPage.infoText')}</p>
        <SupportItem>
          <FaDiscord size={24} color="#7289da" />
          <SupportLink href={DiscordUrl} target="_blank" rel="noopener noreferrer">
            {t('supportPage.discordLink')}
          </SupportLink>
        </SupportItem>
        <SupportItem>
          <FaEnvelope size={24} color="#ff4444" />
          <SupportLink href={SupportEmailMailTo}>
            {SupportEmail}
          </SupportLink>
        </SupportItem>
      </SupportContainer>
    </PageContentComponent>
  );
};

export default SupportPage;

